import { render, staticRenderFns } from "./WorkflowTestTaskServerTable.vue?vue&type=template&id=62136722"
import script from "./WorkflowTestTaskServerTable.vue?vue&type=script&lang=js"
export * from "./WorkflowTestTaskServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports